import axios from "fetch-api/fetch-api";

export function getTiresWidth() {
  return axios.get<string[]>("/get-widths");
}
